import { ActionType } from 'interfaces/generic';
import { PartnerConfig } from 'interfaces/partner-config';
import { SocketActionTypes } from 'store/action-types/socket';

type InitialSocketData = {
  isConnected: boolean;
  reConnected: number;
  partnerConfigs?: PartnerConfig;
  isJackpotConnected: boolean;
};

const initialSocketData: InitialSocketData = {
  isConnected: false,
  reConnected: 0,
  isJackpotConnected: false
};

export const socket = (
  state = initialSocketData,
  action: ActionType
): InitialSocketData => {
  switch (action.type) {
    case SocketActionTypes.SET_IS_CONNECTED:
      return {
        ...state,
        isConnected: action.payload
      };

    case SocketActionTypes.SET_RE_CONNECTED:
      return {
        ...state,
        reConnected: action.payload
      };
    case SocketActionTypes.SET_PARTNER_CONFIGS:
      return {
        ...state,
        partnerConfigs: action.payload
      };
    case SocketActionTypes.SET_IS_JACKPOT_CONNECTED:
      return {
        ...state,
        isJackpotConnected: action.payload
      };

    default: {
      return state;
    }
  }
};
